<div class="modal-header">
    <h4 class="modal-title">Part Alias</h4>
</div>
<div class="modal-body" (keyup.esc)="close()" (keyup.enter)="save()">
    <dx-form [formData]="partAlias" validationGroup="aliasValidationGroup">
        <dxi-item dataField="partAliasTypeId" [label]="{ text: 'Type' }" editorType="dxSelectBox" [editorOptions]="{ dataSource: types, valueExpr: 'id', displayExpr: 'name' }">
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item
            dataField="vendorId"
            [label]="{ text: 'Vendor' }"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: vendorsDS, valueExpr: 'id', displayExpr: 'companyName', showClearButton: false }"
        >
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="partNumber">
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="cost" editorType="dxNumberBox" [editorOptions]="{ format: { type: 'currency', precision: 5 }, step: 0 }">
            <dxi-validation-rule type="required" [message]="'Required'"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="description" editorType="dxTextArea" [editorOptions]="{ height: 100 }"> </dxi-item>
        <dxi-item dataField="packageQuantity"></dxi-item>
        <dxi-item
            dataField="quickBooksLineItemId"
            [label]="{ text: 'Line Item' }"
            editorType="dxSelectBox"
            [editorOptions]="{ dataSource: quickBooksItems, valueExpr: 'id', displayExpr: 'name', showClearButton: false }"
        >
        </dxi-item>
    </dx-form>
</div>
<div class="modal-footer">
    <button class="btn btn-success" (click)="save()">Save</button>
    <button class="btn btn-light" (click)="close()">Cancel</button>
</div>
